import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';

const RegisterPage = () => {
  const [searchParams] = useSearchParams();
  const defaultRole = searchParams.get('role') === 'merchant' ? 'merchant' : 'customer';

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    role: defaultRole,
    storeName: '',
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      await register(formData);
      toast.success('Account created successfully!');
      navigate(formData.role === 'merchant' ? '/merchant/dashboard' : '/');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ maxWidth: '500px' }}>
        <h2 className="auth-title">Create Account</h2>
        <p className="auth-subtitle">Join eBuyWiz today</p>

        {/* Role Toggle */}
        <div className="btn-group w-100 mb-4" role="group">
          <button
            type="button"
            className={`btn ${formData.role === 'customer' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setFormData({ ...formData, role: 'customer' })}
          >
            Customer
          </button>
          <button
            type="button"
            className={`btn ${formData.role === 'merchant' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setFormData({ ...formData, role: 'merchant' })}
          >
            Merchant
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="row mb-3">
            <div className="col-6">
              <label className="form-label">First Name</label>
              <input
                type="text"
                name="firstName"
                className="form-control"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-6">
              <label className="form-label">Last Name</label>
              <input
                type="text"
                name="lastName"
                className="form-control"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              name="email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          {formData.role === 'merchant' && (
            <div className="mb-3">
              <label className="form-label">Store Name</label>
              <input
                type="text"
                name="storeName"
                className="form-control"
                placeholder="Your store name"
                value={formData.storeName}
                onChange={handleChange}
                required={formData.role === 'merchant'}
              />
            </div>
          )}

          <div className="mb-3">
            <label className="form-label">Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                className="form-control"
                style={{ paddingRight: '44px' }}
                value={formData.password}
                onChange={handleChange}
                required
                minLength={6}
              />
              <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: '#9CA3AF', fontSize: '18px' }}>
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label">Confirm Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                name="confirmPassword"
                className="form-control"
                style={{ paddingRight: '44px' }}
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                minLength={6}
              />
              <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: '#9CA3AF', fontSize: '18px' }}>
                {showConfirmPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-ebw-primary w-100 btn-lg"
            disabled={loading}
          >
            {loading ? 'Creating Account...' : 'Create Account'}
          </button>
        </form>

        <p className="text-center mt-4 mb-0">
          Already have an account? <Link to="/login" className="text-primary fw-semibold">Sign In</Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
